import Button from "components/Elements/Button/Button";
import FEATURE_LIST from "../../../../helpers/featuresList";
import Icon from "components/Elements/Icon/Icon";
import PRODUCT_LIST from "../../../../helpers/productList";
import useApp from "hooks/useApp";
import useIsIsraelUser from "../../hooks/useIsIsraelUser";

import { LinkToNewTab } from "components/Elements/Link/Link";
import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./featuresSection.module.scss";

interface FeaturesSectionI extends React.HTMLAttributes<HTMLDivElement> {
  setShowMegaMenuSection: React.Dispatch<
    React.SetStateAction<"features" | "for-businesses" | "">
  >;
}

/**
 * FeaturesSection component represents the features section for the MegaMenu.
 * It shows when the user hovers over the "Features" main menu item.
 */

export const FeaturesSection = (props: FeaturesSectionI) => {
  const { setShowMegaMenuSection, ...restProps } = props;

  const { getTextByKey } = useContent();
  const { theme } = useApp();

  const isIsraelUser = useIsIsraelUser();

  return (
    <div className={styles.sectionWrapper} {...restProps}>
      <div className={`${styles.featureListWrapper} ${styles[theme]}`}>
        <h3 className={styles.sectionMainTitle}>
          JUMBO {getTextByKey("features")}
          {/*@ts-ignore*/}
          <LinkToNewTab page="features" classes={styles.linkWrapper}>
            <Button className={styles.learnMoreButton}>
              {getTextByKey("learn-more")}
            </Button>
          </LinkToNewTab>
        </h3>
        <ul className={styles.featureList} data-testid="feature-list">
          {FEATURE_LIST.map(({ titleKey, descriptionKey, anchor, iconKey }) => {
            return (
              <li
                key={titleKey}
                className={styles.listItem}
                // Close the mega menu when the user clicks on the item
                // in order to see scrolled content on the page.
                onClick={() => setShowMegaMenuSection("")}
              >
                {/*@ts-ignore*/}
                <LinkToNewTab
                  page={`features#${anchor}`}
                  classes={styles.itemLink}
                >
                  {/* Icon name is the same as title key */}
                  <Icon
                    name={`mega-menu/${iconKey}`}
                    blue
                    large
                    alt={iconKey}
                  />
                  <div className={styles.textWrapper}>
                    <h4 className={styles.title}>{getTextByKey(titleKey)}</h4>
                    <p className={styles.description}>
                      {getTextByKey(descriptionKey)}
                    </p>
                  </div>
                </LinkToNewTab>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles[theme]}>
        <h3 className={styles.sectionTitle}>
          {getTextByKey("mega-menu-products-title")}
        </h3>
        <ul className={styles.productList}>
          {PRODUCT_LIST.filter((product) =>
            // Show JUMBOpay only for users from Israel
            product.name === PRODUCT_LIST[2].name ? isIsraelUser : true
          ).map(({ name, descriptionKey }) => (
            <li key={name} className={styles.listItem}>
              {/*@ts-ignore*/}
              <LinkToNewTab page={`jumbo-${name}`} classes={styles.itemLink}>
                <Icon name={`mega-menu/${name}`} large alt={name} />
                <div className={styles.textWrapper}>
                  <h4 className={styles.title}>{"JUMBO" + name}</h4>
                  <p className={styles.description}>
                    {getTextByKey(descriptionKey)}
                  </p>
                </div>
              </LinkToNewTab>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default memo(FeaturesSection);
